import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e9a6e816"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "heading" }
const _hoisted_2 = { class: "fs14" }
const _hoisted_3 = { class: "sub-heading" }
const _hoisted_4 = { class: "items-block" }
const _hoisted_5 = { class: "mt-20 text-right" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_7 = { class: "mt-20" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("一覧へ戻る")

import { onMounted, ref, reactive, watch } from 'vue'
  import { useRoute, useRouter } from 'vue-router';
  import { ProjectAlertFormRepository, AlertForm } from '@/repositories/ProjectAlertFormRepository'
  import { useExceptionMessage } from '@/logic/ExceptionMessageLogic'
  import { ElMessage } from "element-plus"
  import type { ElForm } from 'element-plus'

  type FormInstance = InstanceType<typeof ElForm>
  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const route = useRoute();
  const router = useRouter();

  const alert_form = ref<AlertForm|null>(null);
  const form_values = reactive<any>({});
  const rules = ref<any>({});
  const loading = ref(true);

  const load = async (project_id: number, project_alert_form_id: number) => {
    const repository = new ProjectAlertFormRepository(
      Number(project_id)
    )

    try {
      loading.value = true;

      alert_form.value = await repository.find(Number(project_alert_form_id));

      loading.value = false;

      alert_form.value.alert_form_items.forEach((alert_form_item) => {
        alert_form_item.alert_form_item_fields.forEach((alert_form_item_field) => {
          rules.value[alert_form_item_field.id] = [
            {
              required: alert_form_item_field.required,
              message: alert_form_item_field.title + 'の入力は必須です',
              trigger: 'change',
            },
            {
              message: '数値を入力してください',
              validator: (rule: any, value: any, callback: any) => {
                if (value === '') {
                  callback();
                  return;
                }
                if (!/^-?[0-9.]+$/.test(value)) {
                  callback(new Error('Please input numeric'))
                  return;
                }

                callback();
              },
              trigger: 'change'
            }
          ];

          form_values[alert_form_item_field.id] = alert_form_item_field.value;
        });
      });
    } catch (e: any) {
      useExceptionMessage(e);
    }
  };

  onMounted(() => {
    load(Number(route.params.project_id), Number(route.params.project_alert_form_id));
  });
  watch(() => route.params.project_id, (project_id) => {
    if (project_id) {
      load(Number(project_id), Number(route.params.project_alert_form_id));
    }
  });
  watch(() => route.params.project_alert_form_id, (project_alert_form_id) => {
    if (project_alert_form_id) {
      load(Number(route.params.project_id), Number(project_alert_form_id));
    }
  });

  const form_ref = ref<FormInstance>();

  const handleSave = (form_el: FormInstance | undefined) => {
    if (!form_el) {
      return;
    }

    form_el.validate(async (valid) => {
      if (valid) {
        const repository = new ProjectAlertFormRepository(
          Number(route.params.project_id)
        )

        try {
          await repository.save(
            Number(route.params.project_alert_form_id),
            form_values
          );

          router.push({name: 'ProjectAlertForm'})

          ElMessage({
            showClose: true,
            message: '実績を保存しました',
            type: 'success'
          });
        } catch (e: any) {
          useExceptionMessage(e);
        }
      } else {
        return false
      }
    });
  };

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_component_el_card, null, {
    default: _withCtx(() => [
      (alert_form.value !== null)
        ? (_openBlock(), _createBlock(_component_el_form, {
            key: 0,
            ref: (_value, _refs) => {
              _refs['form_ref'] = _value
              form_ref.value = _value
            },
            model: _unref(form_values),
            rules: rules.value,
            "label-position": "top"
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_1, _toDisplayString(alert_form.value.title), 1),
              _createElementVNode("p", _hoisted_2, "入力期限: " + _toDisplayString(alert_form.value.limited_at), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(alert_form.value.alert_form_items, (alert_form_item) => {
                return (_openBlock(), _createBlock(_component_el_card, {
                  shadow: "never",
                  key: String(alert_form_item.id)
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_3, _toDisplayString(alert_form_item.title), 1),
                    _createElementVNode("div", _hoisted_4, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(alert_form_item.alert_form_item_fields, (alert_form_item_field) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: alert_form_item_field.id,
                          class: "item"
                        }, [
                          _createVNode(_component_el_form_item, {
                            label: alert_form_item_field.title,
                            prop: String(alert_form_item_field.id)
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _unref(form_values)[alert_form_item_field.id],
                                "onUpdate:modelValue": ($event: any) => ((_unref(form_values)[alert_form_item_field.id]) = $event)
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 2
                          }, 1032, ["label", "prop"])
                        ]))
                      }), 128))
                    ])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["model", "rules"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (handleSave(form_ref.value)))
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_router_link, { to: {name: 'ProjectAlertFormList'} }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 512)), [
    [_directive_loading, loading.value]
  ])
}
}

})